import { render, staticRenderFns } from "./energy.vue?vue&type=template&id=a5ed3176&scoped=true"
var script = {}
import style0 from "./energy.vue?vue&type=style&index=0&id=a5ed3176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ed3176",
  null
  
)

export default component.exports